module.exports = __webpack_public_path__ + "static/media/wind-turbines-2.c463417a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/wind-turbines-2.jpeg
// module id = 1837
// module chunks = 0